var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading || _vm.isLoadingLP)?_c('img',{staticClass:"app-loader",attrs:{"src":require("../assets/img/oval.svg"),"width":"50","alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }